import React from 'react';
import LayoutContainer from '../components/LayoutWrapper';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';

const PaymentMethods = () => {
    const { address, email } = useSelector(state => state.shop)

    return (
        <LayoutContainer sx={{
            '& table': {
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: '32px',
                fontSize: '0.95rem',
                textAlign: 'center',
            },
            '& table th, & table td': {
                border: '1px solid #ddd',
                padding: '10px 12px',
            },
            '& table thead': {
                backgroundColor: '#f5f5f5',
                fontWeight: 'bold',
            },
            '& table tr:nth-of-type(even)': {
                backgroundColor: '#fafafa',
            }
        }} >
            <h2>Payment Methods</h2>
            <table>
                <tbody>
                    <tr>
                        <td><strong>Payment Option</strong></td>
                        <td><strong>Information</strong></td>
                    </tr>
                    <tr>
                        <td>Visa</td>
                        <td>We accept Visa card payments, offering a secure and globally trusted method for convenient checkout.</td>
                    </tr>
                    <tr>
                        <td>PayPal</td>
                        <td>Pay securely using your PayPal account or linked bank card. Ideal for buyers who prefer a fast and protected transaction method.</td>
                    </tr>
                    <tr>
                        <td>Stripe</td>
                        <td>Our store is integrated with Stripe, allowing you to pay effortlessly using your credit or debit card through a secure gateway.</td>
                    </tr>
                    <tr>
                        <td>Mastercard</td>
                        <td>Mastercard payments are also accepted, giving you flexibility and confidence when placing your order.</td>
                    </tr>
                </tbody>
            </table>
            <Typography ><b>Address:</b> {address}</Typography>
            <Typography ><b>Email:</b> {email || `support@${window.location.hostname}`}</Typography>
            <Typography ><b>Support Time:</b> 8:00 AM – 5:00PM (EST) (Mon – Fri)</Typography>
        </LayoutContainer >
    );
};

export default PaymentMethods;
